import React, { Component } from "react";
import s from "./styles.scss";
import { Button, FormGroup, Label, Input } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import ConfiguracionMetasTable from "./ConfiguracionMetas.table";
import ConfiguracionMetasRegionalesTable from "./ConfiguracionMetasRegionales.table";
import { ConfiguracionMetasStore } from "../../../containers/comisionesAnualidadConfiguracion/configuracionMetas/ConfiguracionMetas.store";
import { ConfiguracionMetasDispatcher } from "../../../containers/comisionesAnualidadConfiguracion/configuracionMetas/ConfiguracionMetas.dispatcher";
import { ProcesoResultado } from "../../../../types/AnualidadMetaCarga";
import {
  errorNotification,
  successNotification
} from "../../../../utils/notifications";
import { Styled } from "../../../../toolkit/decorators/Artifact";
import { formatPeriodo, formatMoney } from "../../../helpers/formatters";

interface Props extends ConfiguracionMetasStore, ConfiguracionMetasDispatcher {}

interface State {
  selectedFile: File | null;
  selectedMes: string;
  selectedAnio: string;
}

const MESES = [
  { value: "01", label: "Enero" },
  { value: "04", label: "Abril" },
  { value: "07", label: "Julio" },
  { value: "10", label: "Octubre" }
];

@Styled(s)
export default class ConfiguracionMetasComponent extends Component<
  Props,
  State
> {
  state = {
    selectedFile: null,
    selectedMes: "",
    selectedAnio: ""
  };

  componentDidMount() {
    const currentYear = new Date().getFullYear();
    this.setState({ selectedAnio: currentYear.toString() });
  }

  onFileChange = evt => {
    if (evt.target.files && evt.target.files.length > 0) {
      this.setState({ selectedFile: evt.target.files[0] });
    }
  };

  onMesChange = evt => {
    this.setState({ selectedMes: evt.target.value });
  };

  onAnioChange = evt => {
    this.setState({ selectedAnio: evt.target.value });
  };

  getPeriodo = () => {
    const { selectedMes, selectedAnio } = this.state;
    if (!selectedMes || !selectedAnio) return "";
    return `${selectedAnio}-${selectedMes}-01`;
  };

  onUpload = async (confirmar: boolean) => {
    const { selectedFile } = this.state;

    if (!selectedFile) {
      errorNotification("Debe seleccionar un archivo");
      return;
    }

    const periodo = this.getPeriodo();
    if (!periodo) {
      errorNotification("Debe seleccionar mes y año");
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);

    const preview = await this.props.postCargaMetas(
      formData,
      confirmar,
      periodo
    );

    if (preview.fulfilled) {
      const carga = preview.cargaAnualidadMeta;

      if (carga.resultado != ProcesoResultado.ERROR) {
        successNotification(
          confirmar
            ? "Metas cargadas correctamente"
            : "Archivo validado correctamente"
        );
      } else {
        errorNotification(
          confirmar
            ? "El archivo contenía errores"
            : "Verifique el archivo por favor"
        );
      }
    } else {
      errorNotification(
        preview.postingCargaAnualidadMetaError ||
          "Error en la carga del archivo"
      );
    }
  };

  onLoadCurrentMetas = async () => {
    const preview = await this.props.getMetas();

    if (preview.fulfilled) {
      successNotification("Metas actuales cargadas");
    } else {
      errorNotification(
        preview.gettingComisionAnualidadMetasError ||
          "Error al cargar las metas actuales"
      );
    }
  };

  isWaiting = () => {
    return (
      this.props.gettingComisionAnualidadMetas ||
      this.props.postingCargaAnualidadMeta
    );
  };

  spinnerOnWait = (label: string) => {
    return this.isWaiting() ? (
      <FontAwesomeIcon icon={faSpinner} pulse />
    ) : (
      label
    );
  };

  render() {
    const { cargaAnualidadMeta, comisionAnualidadMetas } = this.props;
    const { selectedFile, selectedMes, selectedAnio } = this.state;

    const cargaInfo = cargaAnualidadMeta || comisionAnualidadMetas;

    const hasError = cargaAnualidadMeta
      ? cargaAnualidadMeta.resultado == ProcesoResultado.ERROR
      : false;

    const metasClubes = cargaInfo ? cargaInfo.metasClubes || [] : [];

    const metasRegiones = cargaInfo ? cargaInfo.metasRegiones || [] : [];

    const currentYear = new Date().getFullYear();
    const years = [currentYear, currentYear + 1];

    return (
      <>
        <div className="container">
          <div className="row mt-3">
            <div className="col-md-2">
              <FormGroup>
                <Label for="mes">Mes:</Label>
                <Input
                  type="select"
                  name="mes"
                  id="mes"
                  value={selectedMes}
                  onChange={this.onMesChange}
                  disabled={this.isWaiting()}
                >
                  <option value="">Seleccione un mes</option>
                  {MESES.map(mes => (
                    <option key={mes.value} value={mes.value}>
                      {mes.label}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            </div>

            <div className="col-md-2">
              <FormGroup>
                <Label for="anio">Año:</Label>
                <Input
                  type="select"
                  name="anio"
                  id="anio"
                  value={selectedAnio}
                  onChange={this.onAnioChange}
                  disabled={this.isWaiting()}
                >
                  {years.map(year => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            </div>

            <div className="col-md-2">
              <Button
                type="button"
                className={`${s.primaryButton} ${s.fileButton} mt-4`}
                size="sm"
                block
                disabled={this.isWaiting()}
                onClick={e => {
                  if (this.isWaiting()) {
                    e.preventDefault();
                    e.stopPropagation();
                  }
                }}
              >
                {this.spinnerOnWait("Seleccionar archivo")}
                <input
                  className={s.inputFile}
                  type="file"
                  accept=".xlsx,.xls"
                  title=""
                  disabled={this.isWaiting()}
                  onChange={this.onFileChange}
                />
              </Button>
              {selectedFile && (
                <small className="text-muted d-block mt-1">
                  {selectedFile.name}
                </small>
              )}
            </div>

            <div className="col-md-2">
              <Button
                className={`${s.primaryButton} mt-4`}
                hidden={cargaAnualidadMeta && !hasError}
                type="button"
                size="sm"
                block
                onClick={() => this.onUpload(false)}
                disabled={!selectedFile || this.isWaiting()}
              >
                {this.spinnerOnWait("Verificar archivo")}
              </Button>

              <Button
                className={`${s.primaryButton} mt-4`}
                style={{ marginTop: "0" }}
                hidden={!cargaAnualidadMeta || hasError}
                type="button"
                size="sm"
                block
                onClick={() => this.onUpload(true)}
                disabled={!selectedFile || this.isWaiting()}
              >
                {this.spinnerOnWait("Cargar metas")}
              </Button>
            </div>
          </div>
          {metasClubes.length > 0 && (
            <div className="row">
              <div className="col-12">
                <hr />
              </div>
              <div className="col-12 mt-1" style={{ lineHeight: "40px" }}>
                <strong>Periodo: </strong>
                {formatPeriodo(cargaInfo.periodo)} -&nbsp;
                <strong>Meses: </strong>
                {cargaInfo.meses || 0} -&nbsp;
                <strong>Meta Total: </strong>
                {formatMoney(cargaInfo.metaAcumuladaTotal || 0)}
              </div>
            </div>
          )}
          {metasRegiones.length > 0 && (
            <div className="mt-4">
              <ConfiguracionMetasRegionalesTable
                metasRegiones={metasRegiones}
              />
            </div>
          )}

          {metasClubes.length > 0 && (
            <div className="mt-4">
              <ConfiguracionMetasTable
                metasClubes={metasClubes}
                cargaInfo={cargaAnualidadMeta || comisionAnualidadMetas}
              />
            </div>
          )}
        </div>
      </>
    );
  }
}
